import io from 'socket.io-client'

function getCookie(name) {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop().split(';').shift()
    return ''
}

const socketUrl =
    window.location.host === 'localhost:8080'
        ? 'http://localhost:9001'
        : 'https://rechapi.scheffi.net'

export const socket = io(socketUrl, {
    // ✅ Safari: Polling als Fallback zulassen
    transports: ['polling', 'websocket'],

    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 500,

    // ✅ Token beim Verbindungsaufbau mitsenden
    auth: () => ({
        token: getCookie('jwt'),
    }),

    // Optional: falls du Reverse Proxy /socket.io path nutzt
    // path: '/socket.io',

    // Optional: falls du CORS/Cookies brauchst
    // withCredentials: true,
})